/* firewall.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
            <rect class="foreground-gl" x="10.76" y="9.12" width="9.06" height="4.68"/><rect class="foreground-gl" y="9.12" width="9.49" height="4.68"/><rect class="foreground-gl" x="6.02" y="15" width="8.78" height="4.68"/><rect class="foreground-gl" y="15" width="4.75" height="4.68"/><rect class="foreground-gl" x="16.08" y="15" width="3.74" height="4.68"/><path class="foreground-gl" d="M4.64,8.35h11a8.67,8.67,0,0,0-3.51-6c.27.76.82,2.63.45,2.63C12,4.05,10.06.21,8.78.21c.58.91-.8,4.27-1.08,5.26A21.71,21.71,0,0,1,5.82,3.6C6,5.32,5.14,6.82,4.64,8.35Z" transform="translate(-0.12 -0.21)"/>
        </svg>
    `
};
